import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { HttpService } from 'src/app/service/http/http.service';

import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ChangeNeededComponent } from '../../change-needed/change-needed.component';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
// import { addMonths } from 'date-fns';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-probationfrom-hod-manager',
  templateUrl: './probationfrom-hod-manager.component.html',
  styleUrls: ['./probationfrom-hod-manager.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ProbationfromHODMANAGERComponent implements OnInit {
  buttonColorName: any;
  loggedInUserRole: any;
  loggedInUserCompanyID: any;
  subModuleButtonColor: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any
  selectedYear: any;
  pmsYears: any = [];
  loggedInUserId: any;
  fromYear: any;
  toYear: any;
  from: any;
  getChangedData: any;
  userEmail: any;
  CompanyHrInformation: any;
  emailOfHrAdmin: any;
  firstnameOfHrAdmin: any;
  lastnameOfHrAdmin: any;
  companyHrId: any;
  userId: any;
  recommendedBy: any;
  employeedatas: any;
  reportingManager: any;
  probationCurrentLogUserType: any;
  confirmationProbationWhomSetup: any;
  hrView: any;
  constructor(private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public employeedata: any,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    private encryptionService: EncryptionService,

    public dialogRef: MatDialogRef<ProbationfromHODMANAGERComponent>,
  ) {

    this.employeedatas = employeedata;
    this.userId = employeedata?.userId;
    this.hrView = employeedata.hrView;
    this.probationCurrentLogUserType = employeedata?.probationCurrentLogUserType
  }

  ngOnInit() {

    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.userEmail = sessionStorage.getItem('userEmail');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    // this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getChangedData = sessionStorage.getItem('ProbassionChangedData');
    console.log(this.employeedatas);
    this.reportingManager = this.httpService.reportingManagerForElcm;
    this.recommendedBy = this.employeedatas ? this.employeedatas.recommendedBy : this.loggedInUserRole;
    this.confirmationProbationWhomSetup = this.httpService.confirmationProbationWhomSetup;
    this.getpmsyearlist()
    this.getCompanyDataByCompID();
  }
  // ------------------------------------------------------------------------------------------------------------------

  getCompanyDataByCompID() {

    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {


      this.emailOfHrAdmin = data?.data?.emailOfHrAdmin;
      this.firstnameOfHrAdmin = data?.data?.firstnameOfHrAdmin;
      this.lastnameOfHrAdmin = data?.data?.lastnameOfHrAdmin;
      this.companyHrId = data?.data?.companyHrId;


    })
  }

  // ---------------------------------------------------------------------------------------------------------------------

  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };

  //       // Get current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     // Iterate over the years and set the selected year for various fields
  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';
  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         this.from = 'January-December'
  //         yearValue = `${currentYear}-${currentYear}`; // Calendar year
  //       } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
  //         this.from = 'April-March'
  //         if (new Date().getMonth() < 3) {
  //           // If it's Jan, Feb, or Mar, we're in the previous fiscal year
  //           yearValue = `${currentYear - 1}-${currentYear}`;
  //         } else {
  //           // From Apr onwards, it's the current fiscal year
  //           yearValue = `${currentYear}-${currentYear + 1}`;
  //         }
  //       }

  //       if (ele?.year == yearValue) {
  //         console.log("dgmfdgl");

  //         this.selectedYear = ele?.year;

  //         var test = ele?.year?.split('-');
  //         this.fromYear = test[0];
  //         this.toYear = test[1];
  //         this.probationTableLableFun();
  //         this.getEmployeeList();
  //         this.getEmployee();
  //         this.getConfirmation();
  //         this.getProbationList();
  //         this.getProbationDetailsForHODAndManager();
  //       }


  //     });
  //   })
  // }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      // Additional function calls
      this.probationTableLableFun();
      this.getEmployeeList();
      this.getEmployee();
      this.getConfirmation();
      this.getProbationList();
      this.getProbationDetailsForHODAndManager();
    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');

    }
  }

  closepopup() {
    this.dialog.closeAll();
  }
  employeesDetails: any = []
  employeesProbationDetails: any = []
  getEmployeeList() {

    // this.selectedYear
    this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYear}&fiscalType=Jan_Dec`).subscribe((record: any) => {
      this.employeesDetails = record.data.map((record: any) => {
        return {
          ...record,
          probationStatus: null,
          probationExtensionByDay: null,
          reasonForExtension: null,
          changesPostConfirmation: null,
          dateOfConfirmation: null
        }
      });
      this.getprobationPeriods()

    })
  }
  probationPeriodData: any = []
  getprobationPeriods() {
    this.httpService.callGetService(`${this.config.getProbation}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`)
      .subscribe((record: any) => {
        console.log("API Response:", record);
        this.probationPeriodData = record.data;
        this.getProbationList();
      });
  }


  EmployeeSummaryData: any = [];
  currentemployeesProbationDetails: any = []
  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data.data;

      this.getEmployeeListOnGoal();
    })
  }
  employeeTeamForHod: any = []
  getEmployeeListOnGoal() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "from": "January-December",
      "fromYear": this.fromYear,
      "to": "January-December",
      "toYear": this.toYear,
      "userId": this.loggedInUserId,
      "userType": null,
      "loggedInUserRole": this.loggedInUserRole
    }
    this.httpService.callPostService(this.config.getTeamOfManagerByDate, request).
      subscribe((data: any) => {
        this.employeeTeamForHod = data?.data;

      })
  }
  lineManagerOrHODData: any = [];
  getProbationDetailsForHODAndManager() {
    this.httpService.callGetService(`${this.config.getDetailsLineManagerOrHOD}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`).subscribe((record: any) => {
      if (record) {
        console.log("record", record);
        console.log(this.hrView);

        if (this.hrView == 'HR Admin' || this.hrView == 'Super Admin' || this.hrView == 'PHI Admin') {
          this.lineManagerOrHODData = record?.data.map((res: any) => {
            const matchUser = record?.data.find((elm: any) => elm.userId == res.userId);
            console.log(matchUser);

            return {
              ...res,
              emplCode: res ? res?.empCode || matchUser?.empCode : null,
              probationExtensionByDay: res ? res?.probationExtensionByDay || matchUser?.probationExtensionByDay : null,
              probationStatus: res ? res?.probationStatus || matchUser?.probationStatus : null,
              reasonForExtension: matchUser ? matchUser.reasonForExtension : null,
              probationDetailId: matchUser ? matchUser.probationDetailId : null,
              dateOfConfirmation: matchUser ? matchUser.dateOfConfirmation : res.dateOfConfirmation,
              dateOfJoining: matchUser ? matchUser.doj : res.doj,
            }
          })
        } else if (this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager') {
          console.log(this.employeesProbationDetails);
          this.employeesProbationDetails = this.employeesProbationDetails.filter((record: any) => record.userId == this.userId)
          console.log(this.employeesProbationDetails);

          this.lineManagerOrHODData = this.employeesProbationDetails.map((res: any) => {
            const matchUser = record?.data.find((elm: any) => elm.userId == res.userId);
            console.log(matchUser);

            return {
              ...res,
              probationExtensionByDay: res ? res?.probationExtensionByDay || matchUser?.probationExtensionByDay : null,
              probationStatus: res ? res?.probationStatus || matchUser?.probationStatus : null,
              reasonForExtension: matchUser ? matchUser.reasonForExtension : null,
              probationDetailId: matchUser ? matchUser.probationDetailId : null,
              dateOfConfirmation: matchUser ? matchUser.dateOfConfirmation : res.dateOfConfirmation,
            }
          })
        }

      }
    })
  }
  probationListData: any = [];
  getProbationList() {
    this.httpService.callGetService(`${this.config.getProbationDetailsWithConfirmationDate}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`)
      .subscribe((response: any) => {
        if (!response || !response?.data) return;
        this.probationListData = response?.data;
        this.currentemployeesProbationDetails = this.employeesDetails?.map((employee: any) => {

          // Find probation period based on band and grade
          let probationData = this.probationPeriodData?.find((elm: any) =>
            elm.band === employee.band && elm.grade === employee.grade
          );

          // If no matching probation data, set confirmation date as null
          if (!probationData) {
            return {
              ...employee,
              probationStatus: null,
              probationExtensionByDay: null,
              reasonForExtension: null,
              dateOfConfirmation: null, // Set to null if no match
              changesPostConfirmation: null
            };
          }

          let probationPeriod = probationData.probationPeriod; // Months


          // Find employee probation details
          let matchData = this.probationListData.find((elm: any) =>
            elm.empCode === employee.emplCode && elm.grade === employee.grade
          );

          // Convert joining date
          let dateOfJoining = new Date(employee.dateOfJoining); // Convert to Date object
          let finalConfirmationDate = new Date(dateOfJoining); // Create a new Date instance;




          // Add probation period (in months)
          finalConfirmationDate.setMonth(finalConfirmationDate.getMonth() + probationPeriod);

          // If probation is extended, add extra extension days
          if (matchData?.probationStatus === "Extension") {
            finalConfirmationDate.setDate(finalConfirmationDate.getDate() + matchData.probationExtensionByDay);
          }


          return {
            ...employee, // Keep existing employee data
            probationDetailId: matchData ? matchData?.probationDetailId : null,
            probationStatus: matchData ? matchData?.probationStatus : employee?.probationStatus || null,
            probationExtensionByDay: matchData ? matchData.probationExtensionByDay : employee?.probationExtensionByDay || null,
            reasonForExtension: matchData ? matchData.reasonForExtension : null,
            dateOfConfirmation: matchData?.dateOfConfirmation ? matchData?.dateOfConfirmation : finalConfirmationDate.toISOString().split('T')[0], // Format YYYY-MM-DD
            changesPostConfirmation: matchData ? matchData.changesPostConfirmation : null,
          };
        });
        if (this.loggedInUserRole == 'HR Admin') {
          this.employeesProbationDetails = this.currentemployeesProbationDetails;
        } else if (this.loggedInUserRole == 'Manager') {
          ;

          const employeeId = this.EmployeeSummaryData.map((record: any) => record.id);
          this.employeesProbationDetails = this.currentemployeesProbationDetails.filter((record: any) => this.loggedInUserEmpCode == record.reportingManagerCode);


          this.currentemployeesProbationDetails = this.employeesProbationDetails
        } else if (this.loggedInUserRole == 'HOD') {
          console.log(this.currentemployeesProbationDetails);

          const employeeId = this.employeeTeamForHod.map((record: any) => record.id);
          this.employeesProbationDetails = this.currentemployeesProbationDetails.filter((record: any) => this.loggedInUserEmpCode == record.hodCode);
          this.currentemployeesProbationDetails = this.employeesProbationDetails

        }
        this.getProbationDetailsForHODAndManager();

      });
  }

  employees: any = []
  searchTerm: any = ''; // Holds search input value
  filteredEmployees: any[] = []; // Holds filtered employee list

  filterEmployees() {
    if (!this.searchTerm || this.searchTerm.trim() === '') {
      return this.employees; // Return full list if no search term
    }
    const searchTextLower = this.searchTerm.toLowerCase().trim();

    let data = this.currentemployeesProbationDetails.filter((employee: any) =>
      Object.values(employee).some(value => {
        if (value === null || value === undefined) return false; // Skip null/undefined
        return value.toString().toLowerCase().includes(searchTextLower);
      })
    );

    this.employeesProbationDetails = data;


  }
  DislaySelectedRecord(event: any) {
    this.employeesProbationDetails = this.currentemployeesProbationDetails.slice(0, event.value);
  }

  downloadCSV() {
    const header = ["sr No", "Emp ID", "Emp name", "Dept", "Band", "Grade", "DOJ", "Date off Confirmation", "Probation", "Extention of probation by", "Reasons for confirmation or probation extension"]
    if (this.loggedInUserRole === 'HR Admin') {
      header.push("Change post confirmation");
    }
    const headers = header.map((h: any) => h);
    const rows = this.employeesProbationDetails.map((employee: any, index: any) => [
      index + 1,
      employee.emplCode,
      employee.empName,
      employee.empDept,
      employee.band,
      employee.grade,
      employee.dateOfJoining,
      employee.dateOfConfirmation,
      employee.probationStatus,
      employee.probationExtensionByDay,
      employee.reasonForExtension,
      this.loggedInUserRole === 'HR Admin' ? employee.changesPostConfirmation || '' : '' // Only for HR Admin
    ]);

    let csvContent = "data:text/csv;charset=utf-8,"
      + [headers, ...rows].map(e => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Probation_Details.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  getconfirmationdata: any = [];
  noOfDaysConfirmation: any;
  getConfirmation() {
    // this.httpService.callGetService(`${this.config.getConfirmationSetUp}/${this.loggedInUserCompanyID}`)
    this.httpService.callGetService(`${this.config.getConfirmationSetUp}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`)
      .subscribe((record: any) => {
        this.getconfirmationdata = record.data;

        this.noOfDaysConfirmation = record?.data[0]?.noOfDayBeforeConfirmation;

      })
  }
  isEditable(employee: any): boolean {
    if (!employee.dateOfConfirmation) {
      return false;
    }

    const today = new Date();
    const confirmationDate = new Date(employee.dateOfConfirmation);
    const fiveDaysBefore = new Date(confirmationDate);
    fiveDaysBefore.setDate(confirmationDate.getDate() - this.noOfDaysConfirmation);

    // Condition: Editable if within 5-day window or if confirmation date has passed
    return today >= fiveDaysBefore || today > confirmationDate;
  }


  OfferAndAppointmentTableHeader: any = []

  probationTableLableFun() {

    this.OfferAndAppointmentTableHeader = [
      { label: "Sr.No" },
      { label: "Emp ID" },
      { label: "Emp name" },
      { label: "Dept" },
      { label: "Band" },
      { label: "Grade" },
      { label: "DOJ" },
      { label: "Date off Confirmation" },
      { label: "Probation" },
      { label: "Extention of probation by" },
      { label: "Reasons for confirmation or probation extension" }
    ];

    // Add 'Action' column only if the logged-in user is NOT HR Admin
    console.log(this.loggedInUserRole);

    if (this.loggedInUserRole !== 'HR Admin' && this.loggedInUserRole !== 'Super Admin' && this.loggedInUserRole !== 'PHI Admin') {
      this.OfferAndAppointmentTableHeader.push({ label: 'Action' });
    }


  }






  onClickOpenChangeNeededPopup(userId: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      userID: userId

    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(ChangeNeededComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {


    });
  }
  confirmationFlag: boolean = false;
  confirmationpopp(date: any) {
    console.log(date);
    const currentDate = new Date(); // Get the current date

    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    const day = String(currentDate.getDate()).padStart(2, '0'); // Ensure two digits

    const formattedDate = `${year}-${month}-${day}`;
    console.log(date.dateOfConfirmation == formattedDate);

    this.confirmationFlag = date.dateOfConfirmation == formattedDate || date.dateOfConfirmation <= formattedDate
    console.log(this.confirmationFlag);

    if (!this.confirmationFlag && date.probationStatus == null) {

      const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: "You can't Confirm the Employee before Date of confirmation.",
          btn2: 'OK',
          btn2BgColor: 'red', // Highlight error with red button color
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: true
        }
      });
    }

    return;

  }
  getProbationEmployeeDetails: any;
  getprobationData(employee: any) {
    console.log(employee);
    this.getProbationEmployeeDetails = employee
    console.log(this.probationPeriodData);

  }
  addMonthsToDate(dateString: string, monthsToAdd: number): string {
    const date = new Date(dateString); // Convert string to Date object
    date.setMonth(date.getMonth() + monthsToAdd); // Add months

    // Format the result as YYYY-MM-DD
    return date.toISOString().split("T")[0];
  }

  onProbationChange(event: any) {
    let probationDay = this.probationPeriodData.find(
      (elm: any) => elm.grade === event.grade && elm.band === event.band
    );
    console.log(event.dateOfConfirmation);

    if (event.probationStatus !== 'Extension') {
      event.probationExtensionByDay = '';
      event.probationExtensionByDay = null;
    }
    else if (event.probationStatus === 'Extension') {

      // event.probationExtensionByDay = probationDay ? probationDay.probationPeriod : null;
      // event.dateOfConfirmation = this.addMonthsToDate(event.dateOfConfirmation, probationDay.probationPeriod);
      event.probationExtensionByDay = probationDay ? probationDay.probationExtensionPeriod : null;
      event.dateOfConfirmation = this.addMonthsToDate(event.dateOfConfirmation, probationDay.probationExtensionPeriod);

      console.log(event.dateOfConfirmation);


      // event.dateOfConfirmation = probationDate;

    }
  }

  SaveProbationData(userId: any) {

    if (this.getProbationEmployeeDetails == undefined || this.getProbationEmployeeDetails == null || this.getProbationEmployeeDetails == '') {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Updated successfully',
          btn2: 'OK',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: true,
          showSuccessMessage: false,
          showCloseIcon: false
        }
      });

      // Handle the result of the dialog
      dialogRef.afterClosed().subscribe(() => {
        this.dialog.closeAll();
      });
      return;
    }

    let formData = {
      "probationDetailId": this.getProbationEmployeeDetails?.probationDetailId || null,
      "hrId": this.companyHrId,
      "userId": userId,
      "companyId": this.loggedInUserCompanyID,
      "year": this.selectedYear,
      "fiscalYear": this.loggedInCompanyFiscalyear,
      "empName": this.getProbationEmployeeDetails?.empName,
      "empCode": this.getProbationEmployeeDetails?.emplCode,
      "empDept": this.getProbationEmployeeDetails?.empDept,
      "band": this.getProbationEmployeeDetails?.band,
      "grade": this.getProbationEmployeeDetails?.grade,
      "doj": this.getProbationEmployeeDetails?.dateOfJoining,
      // "probationStatus": "Confirmation", // 1. Confirmation 2. Extension
      "probationStatus": this.getProbationEmployeeDetails?.probationStatus, // 1. Confirmation 2. Extension
      "probationExtensionByDay": this.getProbationEmployeeDetails?.probationExtensionByDay,
      "reasonForExtension": this.getProbationEmployeeDetails?.reasonForExtension,
      "changesPostConfirmation": this.getProbationEmployeeDetails?.changesPostConfirmation, // 1. No_Change 2. Change_Needed
      "dateOfConfirmation": this.getProbationEmployeeDetails?.dateOfConfirmation,
      // "officialEmail": "nikitanalawade2001@gmail.com",
      "hrName": this.firstnameOfHrAdmin + " " + this.lastnameOfHrAdmin,
      "hrEmail": this.emailOfHrAdmin,
      "probationCurrentLogUserType": this.loggedInUserRole == 'Manager' ? ' LINE_MANAGER' : this.loggedInUserRole == 'HOD' ? 'HOD' : null
    }
    if (this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager') {

      this.httpService.callPostService(this.config.addUpdateProbationDetailsForHodAndLine, formData).subscribe((record: any) => {
        if (record) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: record.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.dialog.closeAll();
          });

        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.error || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // Optionally handle any action after closing the error dialog
            console.log('Error dialog closed');
          });
        }

      );
    }
  }
}
